// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2aGvB","title":"Images45_title__Fpyro","images":"Images45_images__30VKl"};